"use strict";

var _ = require('underscore');
var $ = require('dibs-jquery-shim');
var SV = require('server-vars');
var tokenReplace = require('bunsen/helpers/tokenReplace');
var formatPhoneNumber = require('dibs-format-phone-number');
var currencyConstants = require('dibs-currency-helpers/constants');
var root = typeof window === 'undefined' ? global : window;
var bunsen;

require('bunsen/libraries/plugins/jquery.cookie.js');

module.exports = bunsen = root.bunsen = root.bunsen || {};

// note: tokenReplace is passed in so that `bunsen.tokenReplace` is aliased to the actual module
bunsen.getMasqueradeAsUserId = function (cookieName) {
    var masquerader;
    var params;

    if (cookieName !== 'masqueradeSeller' && cookieName !== 'masqueradeBuyer') {
        throw new Error('cookieName must equal "masqueradeBuyer" or "masqueradeSeller"');
    }

    masquerader = $.cookie(cookieName);
    params = {};
    if (masquerader) {
        masquerader = masquerader.split('_');
        masquerader = masquerader[0] === 'S' ? masquerader[2].toLowerCase() + '_' + masquerader[1] : masquerader[1];
        params.userId = masquerader;
    }

    return params;
};
bunsen.whenArray = function (arr) {
    return $.when.apply($, arr);
};
bunsen.gotFiles = function (acceptTypes) {
    var gotFiles = $.Deferred();
    var $input = $("<input type='file'multiple>");
    var fileInput = $input.hide().appendTo(document.body)[0];
    if (acceptTypes) {
        $input.attr('accept', acceptTypes);
    }
    if (undefined === fileInput.files) {
        console.error("file API is not present in your browser");
        gotFiles.failWith(this);
    } else {
        fileInput.onchange = $.proxy(function () {
            gotFiles.resolveWith(this, [fileInput.files]);
        }, this);
    }
    fileInput.click();
    return gotFiles;
};
bunsen.getOn = function (name) {
    return function () {
        return this[name];
    };
};
bunsen.property = function (name) {
    return function (o) {
        return o[name];
    };
};
bunsen.gandalf = function (f, n) { // you shall not pass (more than n arguments to f)!
    if (undefined === n) {
        n = 0;
    }
    return function () {
        Array.prototype.slice.call(arguments, 0, n);
        return f.apply();
    };
};
bunsen.flip = function (f) {
    return function () {
        return f.call(this, arguments[1], arguments[0]);
    };
};
bunsen.callon = function (methodName) {
    var args = _.rest(arguments, 1);
    return function (o) {
        return o[methodName].apply(o, args);
    };
};
bunsen.lshiftargs = function (f) {
    return function () {
        return f.apply(this, _.rest(arguments, 1));
    };
};
// returns a function that returns val. Useful for passing a
// callback to $.Deferred.prototype.then when you know what
// the object is before the deferred finishes
bunsen.ret = function (val) {
    return function () {
        return val;
    };
};
/**
 * Takes in a string and finds the namespaced object or value it represents.
 * Say you have an object obj.super.sub = {val1 : 'something'}
 * Then this function call:
 *      obj.getNamespacedValue('object obj.super.sub.val1')
 * ... should return "something"
 * @param str
 * @returns {object}
 */
bunsen.getNamespacedValue = function (str) {
    var arr = str.split('.');
    var obj = window;

    findObject:
    for (var i = 0; i < arr.length; i++) {
        if (obj[arr[i]]) {
            // If you find the next object in the sequence, then set the obj to it.
            obj = obj[arr[i]];
        } else {
            // The object at this level does not exist. Set to null and break up the loop:
            obj = null;
            break findObject;
        }
    }
    return obj;
};

/**
 * Very simple utility function to kill an event.
 * @param e
 */
bunsen.killE = function (e) {
    if (e && e.preventDefault && e.stopPropagation) {
        e.preventDefault();
        e.stopPropagation();
    }
};

// Sorts an object as opposed to an array and preserves the keys. (Perhaps this belongs in Bunsen.)
bunsen.sortObject = function (obj, compare) {
    return _.object(_.zip(_.keys(obj), _.values(obj)).sort(function (a, b) {
        return compare(a[1], b[1]);
    }));
};
/**
 * Adds dashes to a phone number if in US format
 * @deprecated use dibs-format-phone-number instead
 */
bunsen.formatPhoneNumber = formatPhoneNumber;

/**
 * @param code
 * @returns {string}
 */
bunsen.getCurrencySymbol = function (code) {
    var symbol = code === 'PND' ? 'GBP' : code;
    return currencyConstants.symbols[symbol] || '';
};

// converts "camelCase" to "camel case"
bunsen.camel2spaceCase = function (str, capitalize) {
    return $.trim(str.replace(/^.|[A-Z]/g, function ($1) {
        return " " + $1[capitalize ? 'toUpperCase' : 'toLowerCase']();
    }));
};
// converts "camelCase" to "dealer-camel-case-container"
bunsen.camel2snakeCase = function (str) {
    return str.replace(/[A-Z]/g, function ($1) {
            return "-" + $1.toLowerCase();
        }) + "-container";
};
// converts "snake-case" to "snakeCase"
bunsen.snake2camelCase = function (str) {
    return str.replace(/(-([a-z]))/gi, function ($0, $1, $2) {
        return $2.toUpperCase();
    });
};
// converts "snake_case" to "snake case"
bunsen.snake2spaceCase = function (str) {
    return str.replace(/_/g, ' ');
};

/**
 * Will return any string into a kebab
 * @param  {String} str - String to kebab
 * @return {String}
 */
bunsen.kebab = function(str) {
    var regex = /[^a-zA-Z]|[A-Z]/g;
    return (str || '').toString().replace(regex, function($0) {
        return /[a-zA-Z]/.test($0) ? '-' + $0 : '-';
    }).toLowerCase().
        replace(/\-+/g, '-').
        replace(/^\-*|\-*$/g, '');
};

/**
 * Converts any string into camel case
 * @param  {String} str - String to camel
 * @return {String}
 */
bunsen.camel = function(str) {
    var regex = /[\s_\-\W](.)/g;
    return (str || '').toString().replace(/\w/, function($0) {
            // lowercase first letter
            return $0.toLowerCase();
        }).replace(regex, function(_, $1) {
            return /[a-zA-Z]/.test($1) ? $1.toUpperCase() : '';
        });
};

// lint ignore taken from internet
/* eslint-disable */
/*
 * Title Caps
 *
 * Ported to JavaScript By John Resig - http://ejohn.org/ - 21 May 2008
 * Original by John Gruber - http://daringfireball.net/ - 10 May 2008
 * License: http://www.opensource.org/licenses/mit-license.php
 */
var small = "(a|an|and|as|at|but|by|en|for|if|in|of|on|or|the|to|v[.]?|via|vs[.]?)";
var punct = "([!\"#$%&'()*+,./:;<=>?@[\\\\\\]^_`{|}~-]*)";

bunsen.titleCaps = function (title) {
    var parts = [], split = /[:.;?!] |(?: |^)["Ò]/g, index = 0;

    if (!title) {
        return null;
    }

    // Convert to all lowercase and remove underscores
    title = title.toLowerCase().replace(/_/g, " ");

    while (true) {
        var m = split.exec(title);

        parts.push(title.substring(index, m ? m.index : title.length)
            .replace(/\b([A-Za-z][a-z.'Õ]*)\b/g, function (all) {
                return /[A-Za-z]\.[A-Za-z]/.test(all) ? all : _upper(all);
            })
            .replace(new RegExp("\\b" + small + "\\b", "ig"), _lower)
            .replace(new RegExp("^" + punct + small + "\\b", "ig"), function (all, punct, word) {
                return punct + _upper(word);
            })
            .replace(new RegExp("\\b" + small + punct + "$", "ig"), _upper));

        index = split.lastIndex;

        if (m) {
            parts.push(m[0]);
        }
        else {
            break;
        }
    }

    return parts.join("").replace(/ V(s?)\. /ig, " v$1. ")
        .replace(/(['Õ])S\b/ig, "$1s")
        .replace(/\b(AT&T|Q&A)\b/ig, function (all) {
            return all.toUpperCase();
        });
};

function _lower(word) {
    return word.toLowerCase();
}

function _upper(word) {
    return word.substr(0, 1).toUpperCase() + word.substr(1);
}
/*
 jQuery deparam is an extraction of the deparam method from Ben Alman's jQuery BBQ
 http://benalman.com/projects/jquery-bbq-plugin/
 https://github.com/chrissrogers/jquery-deparam/blob/master/jquery-deparam.js
 */
bunsen.deparam = function (params, coerce) {
    var obj = {},
        coerce_types = { 'true': !0, 'false': !1, 'null': null };

    if (!params) {
        return obj;
    }

    // Iterate over all name=value pairs.
    _.each(params.replace(/\+/g, ' ').split('&'), function (v, j) {
        var param = v.split('='),
            key = decodeURIComponent(param[0]),
            val,
            cur = obj,
            i = 0,

        // If key is more complex than 'foo', like 'a[]' or 'a[b][c]', split it
        // into its component parts.
            keys = key.split(']['),
            keys_last = keys.length - 1;

        // If the first keys part contains [ and the last ends with ], then []
        // are correctly balanced.
        if (/\[/.test(keys[0]) && /\]$/.test(keys[keys_last])) {
            // Remove the trailing ] from the last keys part.
            keys[keys_last] = keys[keys_last].replace(/\]$/, '');

            // Split first keys part into two parts on the [ and add them back onto
            // the beginning of the keys array.
            keys = keys.shift().split('[').concat(keys);

            keys_last = keys.length - 1;
        } else {
            // Basic 'foo' style key.
            keys_last = 0;
        }

        // Are we dealing with a name=value pair, or just a name?
        if (param.length === 2) {
            val = decodeURIComponent(param[1]);

            // Coerce values.
            if (coerce) {
                val = val && !isNaN(val)              ? +val              // number
                    : val === 'undefined'             ? undefined         // undefined
                    : coerce_types[val] !== undefined ? coerce_types[val] // true, false, null
                    : val;                                                // string
            }

            if (keys_last) {
                // Complex key, build deep object structure based on a few rules:
                // * The 'cur' pointer starts at the object top-level.
                // * [] = array push (n is set to array length), [n] = array if n is
                //   numeric, otherwise object.
                // * If at the last keys part, set the value.
                // * For each keys part, if the current level is undefined create an
                //   object or array based on the type of the next keys part.
                // * Move the 'cur' pointer to the next level.
                // * Rinse & repeat.
                for (; i <= keys_last; i++) {
                    key = keys[i] === '' ? cur.length : keys[i];
                    cur = cur[key] = i < keys_last ? cur[key] || (keys[i + 1] && isNaN(keys[i + 1]) ? {} : []) : val;
                }

            } else {
                // Simple key, even simpler rules, since only scalars and shallow
                // arrays are allowed.

                if (_.isArray(obj[key])) {
                    // val is already an array, so push on the next value.
                    obj[key].push(val);

                } else if (obj[key] !== undefined) {
                    // val isn't an array, but since a second value has been specified,
                    // convert val into an array.
                    obj[key] = [obj[key], val];

                } else {
                    // val is a scalar.
                    obj[key] = val;
                }
            }

        } else if (key) {
            // No value was defined, so set something meaningful.
            obj[key] = coerce ? undefined : '';
        }
    });

    return obj;
};
/* eslint-enable */

/**
 * Defers to jQuery.param, however, if jQuery is
 * not present, mimics the functionality for
 * most use cases.
 * @param {object} obj
 * @param {boolean} [traditional=false]
 * @returns {string}
 */
bunsen.queryStringFromObj = function (obj, traditional) {
    if ($ && $.param) {
        return $.param(obj, traditional);
    }
    var params = [];
    var add = function (val, key) {
        var i = 0;
        if (_.isArray(val)) {
            for (i; i < val.length; i++) {
                add(val[i], (traditional ? key : key + '[]'));
            }
        } else if (val && typeof val === 'object') {
            console.error('bunsen.queryStringFromObject does not support nested objects if jQuery.param is unavailable');
        } else {
            params.push(encodeURIComponent(key) + '=' + encodeURIComponent(val));
        }
    };
    _.each(obj, add);
    return params.join('&').replace(/%20/g, '+');
};

/**
 * add URL params to backbone model or backbone collection URL
 * @param model - backbone model or backbone collection
 * @param object - a map of key/value pairs to be appended to the URL
 * @param [traditional] {boolean} use the traditional method of serializing arrays and objects to query params
 */
bunsen.extendURL = function (url, object, traditional) {
    var urlArray = url.split('?');
    var queries;

    queries = urlArray[1] ? bunsen.deparam(urlArray[1]) : {};
    _.extend(queries, object);
    return urlArray[0] + '?' + bunsen.queryStringFromObj(queries, traditional);
};

bunsen.replaceURLQueryParams = function (url, object, traditional) {
    var innerUrl = url.split('?')[0];

    return innerUrl + '?' + bunsen.queryStringFromObj(object, traditional);
};

bunsen.getToken = function () {
    var token;
    var tokenObj = {};
    var userData = bunsen.getAdminUserData();
    var sellerData = bunsen.getSellerData();

    if (typeof window === 'undefined') {
        return {};
    }

    //Set user token for masquerade
    if (sellerData && userData) {
        token = $.cookie('userToken') ? $.cookie('userToken') : userData.token;
        tokenObj.userToken = token;
    //Be extra sure we only send the sellerToken when we're on an Admin page
    } else if (sellerData) {
        token = sellerData.token;
        tokenObj.sellerToken = token;
    } else if ($.cookie('userToken')) {
        token = $.cookie('userToken');
        tokenObj.userToken = token;
    }
    return token ? tokenObj : null;
};

bunsen.getAdminUserData = function () {
    return SV.get('userData');
};

bunsen.getSellerData = function () {
    return SV.get('sellerData');
};

/**
 * @see {@link tokenReplace}
 * @deprecated
 */
bunsen.tokenReplace = tokenReplace;

/**
 * strips html tags from a string
 * modified from php.js - http://phpjs.org/functions/strip_tags/ - [insecure] whitelist
 *  functionality and php comment support was removed.
 * @param input {string} the string to remove tags in
 * @returns {string} the string with tags removed
 */
bunsen.stripTags = function (input) {
    input = typeof input === 'string' ? input : '';
    return input.replace(/<\/?([a-z][a-z0-9]*)\b[^>]*>/gi, '');
};


/**
 * Shortcut for jquery's deep clone
 * @param obj {Object} the object to clone
 */
bunsen.deepClone = function (obj) {
    return $.extend(true, {}, obj);
};

/**
 * Like _.result but lets you pass in a context
 * @param obj
 * @param prop
 * @param context
 * @returns {*}
 */
bunsen.result = function (obj, prop, context) {
    if (!obj) {
        return;
    }
    if (_.isFunction(obj[prop])) {
        return obj[prop].call(context || obj);
    }
    return obj[prop];
};



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/libraries/bunsen.js
// module id = 21
// module chunks = 62